module.exports = __webpack_public_path__ + "static/kiwi-12b696190b8641f5993e412b3ad648a6.svg";